module.exports = __webpack_public_path__ + "img/dish1.44ca79e1.png";